import { compareValues, type ChangeRecord } from './utils'

export function ChangeField({ change }: { change: ChangeRecord }) {
  const { before, after } = compareValues(change)

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-body text-gray-500 mb-1">Before</p>
        <pre className="text-body bg-gray-50 p-2 rounded border overflow-x-auto whitespace-pre-wrap break-words">
          {before}
        </pre>
      </div>
      <div>
        <p className="text-body text-gray-500 mb-1">After</p>
        <pre className="text-body bg-gray-50 p-2 rounded border overflow-x-auto whitespace-pre-wrap break-words">
          {after}
        </pre>
      </div>
    </div>
  )
}
